var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollegeStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_868_6912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45703 9.07031H26.543V2.10938H28.2656V8.15625H30.375V2.10938H32.2383V0H3.76172V2.10938H9.45703V9.07031Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5664 13.3275C11.5664 16.875 14.4525 19.7611 18 19.7611C21.5475 19.7611 24.4336 16.875 24.4336 13.3275V11.1797H11.5664V13.3275Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4262 20.0527L18 31.4467L9.57376 20.0527C5.56952 21.0811 2.60156 24.7214 2.60156 29.0417V36.001H33.3984V29.0417C33.3984 24.7214 30.4305 21.0811 26.4262 20.0527Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0164 19.7607H23.6132C22.1106 21.0736 20.1462 21.8701 17.9989 21.8701C15.8517 21.8701 13.887 21.0736 12.3846 19.7607H11.9814L17.9989 27.8978L24.0164 19.7607Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_868_6912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeStudent);
export default __webpack_public_path__ + "static/media/college_student.ef2f8b558c3c872bc3b5da87f1e4d578.svg";
export { ForwardRef as ReactComponent };